// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface SocialMediaPost {
  id: string;
  platform: 'instagram' | 'x';
  content: string;
  media_url?: string;
  media_type?: 'image' | 'video' | 'carousel';
  post_url?: string;
  posted_at: string;
  likes_count: number;
  comments_count: number;
  engagement_rate: number;
}

export const useSocialMediaPosts = () => {
  const [posts, setPosts] = useState<SocialMediaPost[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPosts = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const { data, error: fetchError } = await supabase
        .from('social_media_posts')
        .select('*')
        .eq('is_visible', true)
        .order('posted_at', { ascending: false })
        .limit(10);

      if (fetchError) {
        throw fetchError;
      }

      setPosts(data || []);
    } catch (err) {
      console.error('Error fetching social media posts:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch posts');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return {
    posts,
    isLoading,
    error,
    refetch: fetchPosts
  };
};